/** Combat events record the defender BEFORE conquest. Missing/neutral owners
 * must not inherit a real player's color (in particular, player 2's blue). */
export function attackResultColor(
  playerId: string,
  colorSlotByPlayerId: Record<string, number>,
  playerColorHex: (slot: number) => string,
): string {
  const slot = colorSlotByPlayerId[playerId]
  return playerId && slot !== undefined && slot > 0 ? playerColorHex(slot) : '#888888'
}
